module.exports = __webpack_public_path__ + "static/media/Week10_2.ce25c16d.pdf";